import { render, staticRenderFns } from "./TestPackModal.vue?vue&type=template&id=3c46726d&scoped=true"
import script from "./TestPackModal.vue?vue&type=script&lang=js"
export * from "./TestPackModal.vue?vue&type=script&lang=js"
import style0 from "./TestPackModal.vue?vue&type=style&index=0&id=3c46726d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c46726d",
  null
  
)

export default component.exports